import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import moment from "moment-timezone";
import "moment/locale/pt-br";
import Vue from "vue";
import VueAuthenticate from "vue-authenticate";
import VueMoment from "vue-moment";
import { Vuelidate } from "vuelidate";
import App from "./App.vue";
import Config from "./core/config";
import filters from "./filters";
import "./plugins/axios";
import "./plugins/fontawesome";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

moment.locale("pt-br");
moment.tz.setDefault("America/Recife");
Vue.use(BootstrapVue);
Vue.use(VueMoment, {
  moment
});
Vue.use(Vuelidate);

const molConfig = new Config(process.env.NODE_ENV || "development").getConfig();

axios.defaults.baseURL = molConfig.baseUrl;

Vue.use(VueAuthenticate, {
  baseUrl: molConfig.vueAuth,
  tokenName: "access_token",
  tokenPath: "access_token",
  providers: {
    google: {
      responseType: "token",
      scope: [
        "openid",
        "profile",
        "email",
        "https://www.googleapis.com/auth/user.birthday.read"
      ],
      clientId: molConfig.google.clientId || "681146735072-osvebcsnu3k48gee5asq0ojf3dn4qsd3.apps.googleusercontent.com",
      redirectUri: molConfig.google.redirectUri || "https://agendamento.quarkclinic.com.br"
    },
    facebook: {
      responseType: "token",
      scope: ["email"],
      clientId: molConfig.facebook.clientId || "2198927940197076",
      redirectUri: molConfig.facebook.redirectUri || "https://agendamento.quarkclinic.com.br"
    }
  }
});

Vue.use({
  install: function(Vue) {
    Vue.prototype.$jQuery = require("jquery");
  }
});

Vue.prototype.$serverHost = molConfig.baseUrl;

export const axiosInstance = axios.create({
  baseURL: Vue.prototype.$serverHost
});


axiosInstance.interceptors.request.use(config => {
  store.commit("loading/INCREMENT_LOADING");
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    store.commit("loading/DECREMENT_LOADING");
    return response;
  },
  error => {
    store.commit("loading/DECREMENT_LOADING");

    const contextUrl = error.config.url.split("/").pop();
    const { status, data } = (error && error.response) || {};

    let title = "Erro";
    let text =
      "A aplicação se comportou de forma inesperada, por favor entre em contato com a administração do sistema.";
    let variant = "danger";

    if (status === 401 && contextUrl !== "login") {
      variant = "warning";

      title = "Aviso";
      text = "Seu login expirou. Por favor, faça login novamente.";

      store.dispatch("logoff");
      router.push(`/index/${router.currentRoute.params.organizationId}`);
    } else if (status > 0) {
      variant = "danger";

      title = "Erro";
      text = (data && data.message) || text;
    } else {
      variant = "danger";

      title = "Não foi possível concluir a operação";
      text = "Verifique sua conexão com a internet e tente novamente.";
    }

    const message = h("div", [
      text,
      h("br"),
      h("br"),
      h("small", [
        `[${status || '0'}] ${error.config.url.replace(error.config.baseURL, "")}`
      ]),
      h("br"),
      h("small", [moment().format("DD/MM/YYYY [às] HH:mm:ss")])
    ]);

    vm.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 10000,
      appendToast: true
    });

    return Promise.reject(error);
  } 
);

const requiredMount = (el, binding) => {
  if (!binding.hasOwnProperty("value") || binding.value) {
    el.classList.add("required-indicator");
  } else {
    el.classList.remove("required-indicator");
  }
};

Vue.directive("required", {
  bind: requiredMount,
  update: requiredMount
});

Vue.use(filters);

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
const h = vm.$createElement;
